import { CellContext } from '@tanstack/react-table';
import { memo } from 'react';
import * as React from 'react';
import { FormField } from '../../FormField';
import { FormInputPreviewProps } from '../../input';
import { getFormTableFieldName } from './utils';

export type FormTablePreviewOnlyFieldProps<RowData> = CellContext<
  RowData,
  any
> &
  Pick<FormInputPreviewProps, 'render'>;

export const FormTablePreviewOnlyField = (memo as <T>(c: T) => T)(
  <RowData,>(props: FormTablePreviewOnlyFieldProps<RowData>) => {
    const { render, ...rest } = props;
    return (
      <FormField
        size="small"
        name={getFormTableFieldName(rest)}
        preview={{ previewOnly: true, render }}
      />
    );
  }
);
